export default "__VITE_ASSET__F0i3Me65__"